import type { ReactNode } from "react";

const marketData = [
  { label: "TAM (UK immigration)", value: "£3.29B" },
  { label: "Applications per year", value: "4.2M" },
  { label: "SAM (professionally represented)", value: "£592M" },
  { label: "SOM (10% penetration)", value: "£59M" },
  { label: "Regulated firms (UK)", value: "5,089" },
  { label: "Global TAM", value: "£24.4B" },
];

const tailwinds: { title: string; description: string; icon: ReactNode }[] = [
  {
    title: "Massively fragmented",
    description: "5,089 small firms, most 1-5 people, many owners want to exit",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2" /><path d="M9 22v-4h6v4" /><path d="M8 6h.01" /><path d="M16 6h.01" /><path d="M12 6h.01" /><path d="M12 10h.01" /><path d="M12 14h.01" /><path d="M16 10h.01" /><path d="M16 14h.01" /><path d="M8 10h.01" /><path d="M8 14h.01" /></svg>,
  },
  {
    title: "EU AI Act (Aug 2026)",
    description: "raises compliance bar — small firms can't handle it alone",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>,
  },
  {
    title: "US VCs deploying",
    description: "$B+ into AI roll-ups (GC, Thrive, Lightspeed) — UK is wide open",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" /></svg>,
  },
  {
    title: "Already live in 3 countries",
    description: "ProActive Legal (AU/NZ) deploying, SG pipeline active",
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>,
  },
];

export function MarketSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          A fragmented market.<br />Ready for consolidation
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-8 mt-4">
        {/* Market data */}
        <div>
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            UK Immigration Legal Services
          </div>
          <div className="space-y-2">
            {marketData.map((d, i) => (
              <div
                key={d.label}
                className="flex justify-between items-baseline text-[12px] pb-2"
                style={{ borderBottom: i < marketData.length - 1 ? "1px solid var(--color-border)" : "none" }}
              >
                <span className="text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)]">{d.label}</span>
                <span className="font-bold text-[var(--color-fg)]">{d.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Tailwinds */}
        <div>
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            Tailwinds
          </div>
          <div className="space-y-3">
            {tailwinds.map((t) => (
              <div key={t.title} className="flex items-center gap-3">
                <span className="text-[var(--color-fg-tertiary)] shrink-0 w-4 h-4 flex items-center justify-center [&>svg]:w-full [&>svg]:h-full">{t.icon}</span>
                <div className="text-[12px] text-[var(--color-fg-secondary)]">
                  <strong className="text-[var(--color-fg)] font-medium">{t.title}</strong> — {t.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
